import { useNavigate } from 'react-router-dom'
import { useHomeViewModel } from '../hooks/useHomeViewModel'
import { NonnaMiniCard } from '../../../components/shared/NonnaMiniCard'
import { TrustBadge } from '../../../components/shared/TrustBadge'
import { theme } from '../../../core/design-system/theme'

const styles = {
  page: {
    minHeight: '100dvh',
    background: theme.colors.cream,
    paddingBottom: '90px',
  },
  hero: {
    background: `linear-gradient(135deg, ${theme.colors.terracotta}, ${theme.colors.terracottaLight})`,
    padding: '56px 20px 32px',
  },
  heroPre: {
    fontFamily: theme.fonts.body,
    fontSize: '13px',
    color: 'rgba(255,255,255,0.8)',
    margin: '0 0 6px',
  },
  heroTitle: {
    fontFamily: theme.fonts.display,
    fontWeight: 600,
    fontSize: 'clamp(22px, 6vw, 30px)',
    color: '#fff',
    margin: '0 0 8px',
    lineHeight: 1.25,
  },
  heroSub: {
    fontFamily: theme.fonts.body,
    fontSize: '13px',
    color: 'rgba(255,255,255,0.85)',
    margin: '0 0 20px',
  },
  heroBtn: {
    display: 'inline-block',
    fontFamily: theme.fonts.body,
    fontWeight: 700,
    fontSize: '13px',
    color: theme.colors.terracotta,
    background: '#fff',
    border: 'none',
    borderRadius: `${theme.layout.buttonRadius}px`,
    padding: '10px 18px',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'opacity 0.15s ease',
  },
  section: {
    padding: '20px 0 0',
  },
  sectionTitle: {
    fontFamily: theme.fonts.body,
    fontWeight: 700,
    fontSize: '14px',
    color: theme.colors.textPrimary,
    margin: '0 0 12px',
    padding: '0 20px',
  },
  scrollRow: {
    display: 'flex',
    gap: '12px',
    overflowX: 'auto',
    paddingInline: '20px',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    paddingBottom: '4px',
  },
  trustSection: {
    padding: '20px',
  },
  trustChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  skeleton: {
    background: theme.colors.border,
    borderRadius: '12px',
    opacity: 0.5,
  },
  errorText: {
    fontFamily: theme.fonts.body,
    fontSize: '13px',
    color: theme.colors.textSecondary,
    padding: '0 20px',
  },
}

export function HomeView({ repository }) {
  const { status, nonnas, error, trustLabels } = useHomeViewModel(repository)
  const navigate = useNavigate()

  return (
    <main style={styles.page} className="page-enter">
      {/* Hero */}
      <section style={styles.hero}>
        <p style={styles.heroPre}>Good evening</p>
        <h1 style={styles.heroTitle}>Find your Nonna<br />for tonight</h1>
        <p style={styles.heroSub}>Trusted caregivers available near you right now</p>
        <button
          style={styles.heroBtn}
          onClick={() => navigate('/book/info')}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.85')}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
        >
          Book a Nonna
        </button>
      </section>

      {/* Available Nonnas */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Available nearby</h2>

        {status === 'loading' || status === 'idle' ? (
          <div style={styles.scrollRow}>
            {[1, 2, 3].map((k) => (
              <div key={k} style={{ ...styles.skeleton, width: '110px', height: '130px', flexShrink: 0 }} />
            ))}
          </div>
        ) : status === 'failed' ? (
          <p style={styles.errorText}>{error}</p>
        ) : (
          <div style={styles.scrollRow}>
            {nonnas.map((nonna) => (
              <NonnaMiniCard key={nonna.id} nonna={nonna} />
            ))}
          </div>
        )}
      </section>

      {/* Trust chips */}
      <section style={styles.trustSection}>
        <h2 style={styles.sectionTitle} style={{ padding: 0, margin: '0 0 12px' }}>
          Why parents love Nonna
        </h2>
        <div style={styles.trustChips}>
          {trustLabels.map((label) => (
            <TrustBadge key={label} label={label} withIcon />
          ))}
        </div>
      </section>
    </main>
  )
}

export default HomeView
